import { render, staticRenderFns } from "./NewsDimensionsTab.vue?vue&type=template&id=214a1dde"
import script from "./NewsDimensionsTab.vue?vue&type=script&lang=js"
export * from "./NewsDimensionsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports